// Deixa o número do WhatsApp legível.
//
// O que vem do WhatsApp é só dígito: "556196080740". Lido assim, ninguém
// reconhece o próprio contato — e conferir se é o número certo antes de
// apagar ou abrir conversa vira exercício de contar caracteres.
//
// Grupo não tem telefone: o identificador é um número longo do próprio
// WhatsApp, e formatá-lo como celular seria mentira.

// Celular brasileiro: 55 + DDD (2) + 9 dígitos.  → +55 (61) 99608-0740
// Fixo brasileiro:    55 + DDD (2) + 8 dígitos.  → +55 (61) 3608-0740
const BRASIL_CELULAR = /^55(\d{2})(\d{5})(\d{4})$/;
const BRASIL_FIXO = /^55(\d{2})(\d{4})(\d{4})$/;

export const formatarNumero = (valor, ehGrupo = false) => {
  const digitos = String(valor || "").replace(/\D/g, "");

  if (!digitos) return "";

  // O id de grupo passa de 15 dígitos e não tem forma de telefone.
  if (ehGrupo || digitos.length > 15) return digitos;

  const celular = BRASIL_CELULAR.exec(digitos);
  if (celular) {
    return `+55 (${celular[1]}) ${celular[2]}-${celular[3]}`;
  }

  const fixo = BRASIL_FIXO.exec(digitos);
  if (fixo) {
    return `+55 (${fixo[1]}) ${fixo[2]}-${fixo[3]}`;
  }

  // Número de fora: agrupa de trás para frente, que é como se lê telefone.
  // Melhor um agrupamento genérico do que fingir um formato que não é o do
  // país de origem.
  if (digitos.length > 6) {
    const inicio = digitos.slice(0, digitos.length - 8);
    const meio = digitos.slice(-8, -4);
    const fim = digitos.slice(-4);
    return `+${inicio} ${meio}-${fim}`;
  }

  return digitos;
};

export default formatarNumero;
